var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2929 18.7071C14.6834 19.0976 15.3166 19.0976 15.7071 18.7071C16.0976 18.3166 16.0976 17.6834 15.7071 17.2929L14.2929 18.7071ZM9 12L8.29289 11.2929C7.90237 11.6834 7.90237 12.3166 8.29289 12.7071L9 12ZM15.7071 6.70711C16.0976 6.31658 16.0976 5.68342 15.7071 5.29289C15.3166 4.90237 14.6834 4.90237 14.2929 5.29289L15.7071 6.70711ZM15.7071 17.2929L9.70711 11.2929L8.29289 12.7071L14.2929 18.7071L15.7071 17.2929ZM9.70711 12.7071L15.7071 6.70711L14.2929 5.29289L8.29289 11.2929L9.70711 12.7071Z",
    fill: "#5268AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronLeft);
export default __webpack_public_path__ + "static/media/iconChevronLeft.63d702b538850890d0dbaadb56babc6b.svg";
export { ForwardRef as ReactComponent };